import { useState, useEffect } from 'react'
import { Box, Container } from '@chakra-ui/react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { onAuthStateChanged, User } from 'firebase/auth'
import { auth } from 'services/firebase'
import { TopNav as Nav, Logo, Footer } from 'components'
import { AuthRoute } from './AuthRoute'
import { ProtectedRoute } from './ProtectedRoute'

import { Home } from 'pages/Home'
import { About } from 'pages/About'
import { FAQ } from 'pages/FAQ'
import { Searches } from 'pages/Searches'
import { Search } from 'pages/Search'
import { Signup } from 'pages/Signup'
import { Login } from 'pages/Login'

import { userContext } from 'context/userContext'

export const Router = () => {
  const [currentUser, setCurrentUser] = useState<User | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setLoading(true)
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user)
      } else {
        setCurrentUser(undefined)
      }
      setLoading(false)
    })
  }, [])

  return (
    <userContext.Provider value={{ user: { data: currentUser, loading } }}>
      <BrowserRouter>
        <Nav />
        <Box w='100%'>
          <Container maxW='xl'>
            <Logo />
          </Container>
        </Box>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route
            path='/searches'
            element={
              <ProtectedRoute hasUser={Boolean(currentUser)}>
                <Searches />
              </ProtectedRoute>
            }
          />
          <Route
            path='/searches/:id'
            element={
              <ProtectedRoute hasUser={Boolean(currentUser)}>
                <Search />
              </ProtectedRoute>
            }
          />
          <Route
            path='/signup'
            element={
              <AuthRoute hasUser={Boolean(currentUser)}>
                <Signup />
              </AuthRoute>
            }
          />
          <Route
            path='/login'
            element={
              <AuthRoute hasUser={Boolean(currentUser)}>
                <Login />
              </AuthRoute>
            }
          />
          <Route path='/about' element={<About />} />
          <Route path='/faq' element={<FAQ />} />
          <Route path='*' element={<Home />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </userContext.Provider>
  )
}
